import { FC } from 'react'
import Typography from '@/ui/components/typography'
import { ActionPlanMessageType } from '../ActionPlan/actionPlanConfig.types'
import { ActionPlanItemProps } from './ActionPlanItem.types'
import {
    ItemWrapper,
    IconWrapper,
    ContentWrapper,
    ActionArrowWrapper,
} from './ActionPlanItem.styles'
import AlertIcon from '@assets/images/action-plan-alert-icon.svg?react'
import ImportantIcon from '@assets/images/action-plan-important-icon.svg?react'
import MDRIcon from '@assets/images/action-plan-mdr-icon.svg?react'
import LowPriorityIcon from '@assets/images/action-plan-low-priority-icon.svg?react'
import GeneralIcon from '@assets/images/action-plan-general-icon.svg?react'
import LongArrowRightIcon from '@assets/images/long-arrow-right-icon.svg?react'

const iconByActionPlanMessageType: Record<ActionPlanMessageType, JSX.Element> =
    {
        'security-alert': <AlertIcon />,
        'critical-issues': <AlertIcon />,
        'important-action': <ImportantIcon />,
        mdr: <MDRIcon />,
        'low-priority-action': <LowPriorityIcon />,
        'low-priority-issues': <LowPriorityIcon />,
        general: <GeneralIcon />,
    }

const ActionPlanItem: FC<ActionPlanItemProps> = ({
    message: { id, type, redirection, title, callToAction },
    onAction,
}) => {
    return (
        <ItemWrapper
            type={type}
            onClick={onAction}
            data-testid={`action-plan-item-${id}`}
        >
            <IconWrapper type={type}>
                {iconByActionPlanMessageType[type]}
            </IconWrapper>
            <ContentWrapper type={type}>
                <Typography variant="s-regular" className="title">
                    {title}
                </Typography>
                <Typography variant="xs-regular" className="call-to-action">
                    {callToAction}
                </Typography>
            </ContentWrapper>
            {redirection && (
                <ActionArrowWrapper>
                    <LongArrowRightIcon />
                </ActionArrowWrapper>
            )}
        </ItemWrapper>
    )
}

export default ActionPlanItem
